import axios from 'axios';

axios.defaults.baseURL = 'https://c9b0-103-177-203-246.in.ngrok.io/api';

export default axios;
